import {EstadoSaludSchema} from '@cnc/contracts';
import {useQuery} from '@tanstack/react-query';
import {pedir} from '../api/cliente';
import {tr} from '../i18n/idioma';

// Franja del ambiente de pruebas (decision 0065): arriba de todo, para que
// nadie la confunda con la app de produccion. En produccion no sale nada.
export function FranjaDeAmbiente() {
  const salud = useQuery({
    queryKey: ['salud', 'ambiente'],
    queryFn: () => pedir('salud', EstadoSaludSchema),
    staleTime: 10 * 60_000,
    retry: 1,
  });
  if (salud.data?.ambiente !== 'pruebas') return null;
  return (
    <div
      role="note"
      className="sticky top-0 z-50 bg-dorado px-4 py-1 text-center text-xs font-semibold tracking-wide text-tinta uppercase"
      data-prueba="franja-de-pruebas"
    >
      {tr(
        'Ambiente de pruebas · solo administradores · lo que se haga aquí no cambia la app de producción',
        'Test environment · administrators only · nothing done here changes the production app',
      )}
    </div>
  );
}
